module.exports = __webpack_public_path__ + "static/img/uy.b0ab5d4c.svg";